import React from 'react'
import {Lecturecomp} from '../Componets/Lectures/Lecturecomp.jsx'
import Footer from '../Componets/layout/Footer/footer'

export const Lecture = () => {
  return (
    <>
        <Lecturecomp/>
        <Footer/>
    </>
  )
}
